import React from 'react';

export default class Loading extends React.Component {
    render () {
        return (
            <div className="lds-css ng-scope">
                <div className="lds-rolling">
                    <div/>
                </div>
                {this.props.message ? this.props.message : "Nahrávám data..."}
            </div>
        );
    }
}


/** WEBPACK FOOTER **
 ** ./src/components/Loading/index.js
 **/